import { render, staticRenderFns } from "./WizardModalAddNewShippingMethod.vue?vue&type=template&id=c847be3e&scoped=true&"
import script from "./WizardModalAddNewShippingMethod.vue?vue&type=script&lang=js&"
export * from "./WizardModalAddNewShippingMethod.vue?vue&type=script&lang=js&"
import style0 from "./WizardModalAddNewShippingMethod.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./WizardModalAddNewShippingMethod.vue?vue&type=style&index=1&id=c847be3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c847be3e",
  null
  
)

export default component.exports